import { useEffect, useRef, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { isAuthzAppType } from "../utilities/authzPermissions";

import {

  fetchAuthMeContext,

  resolveKeycloakUserKey,

} from "../utilities/authzClient";



/**

 * Load AuthZ /auth/me after login via POS for HOMS, HPRMS, HPOS, ACCOUNTS.

 * Non-blocking: role-based shell still works if AuthZ is unavailable.

 * Re-fetches when the tab regains focus (after profile changes in Usermanagement-View).

 */

export function useAuthzBootstrap({ authenticated, appType }) {

  const dispatch = useDispatch();

  const companyName = useSelector((s) => s.globalState?.companyName);

  const basePath = useSelector((s) => s.globalState?.basePath);

  const token = useSelector((s) => s.usersState?.token);

  const authUser = useSelector((s) => s.authReducer?.user);

  const fetchedFor = useRef("");

  const [refreshNonce, setRefreshNonce] = useState(0);



  useEffect(() => {

    const onFocus = () => setRefreshNonce((n) => n + 1);

    window.addEventListener("focus", onFocus);

    return () => window.removeEventListener("focus", onFocus);

  }, []);



  useEffect(() => {

    if (!authenticated || !isAuthzAppType(appType) || !companyName || !basePath || !token) {

      return;

    }

    const userKey = resolveKeycloakUserKey(authUser);

    if (!userKey) {

      return;

    }

    const cacheKey = `${companyName}|${basePath}|${userKey}|${refreshNonce}`;

    if (fetchedFor.current === cacheKey) {

      return;

    }

    fetchedFor.current = cacheKey;



    let cancelled = false;

    dispatch({ type: "AUTHZ_LOADING" });

    fetchAuthMeContext({

      companyName,

      keycloakUserId: userKey,

      appType,

    })

      .then((payload) => {

        if (cancelled) return;

        dispatch({ type: "AUTHZ_SUCCESS", payload });

      })

      .catch((err) => {

        if (cancelled) return;

        console.warn("AuthZ /auth/me via POS failed (keeping role-based UI):", err?.message || err);

        dispatch({

          type: "AUTHZ_FAILURE",

          payload: err?.message || "auth/me failed",

        });

        fetchedFor.current = "";

      });



    return () => {

      cancelled = true;

    };

  }, [authenticated, appType, companyName, basePath, token, authUser, dispatch, refreshNonce]);

}



export default useAuthzBootstrap;

